import React from "react";
import { updateProfile, listSpecializations } from "./api";
import "semantic-ui-css/semantic.min.css";
import { Input } from "@mobiscroll/react5";
// import deleteIcon from "src/assets/icons/delete.svg";
// import editIcon from "src/assets/edit.svg";
// import { Listview } from "@mobiscroll/react";
// import save_pink from "src/assets/save_pink.svg";
import { Modal } from "react-bootstrap";
import Loader from "src/components/Dashboard/common/Loader";
import { useState, useCallback, useRef, useEffect } from "react";
import _debounce from "lodash/debounce";

// function MyListItem(props) {
//   const { handleEdit = () => { }, handleDelete = () => { } } = props;
//   console.log(props);
//   return (
//     <li className="d-flex justify-content-between align-items-center">
//       {props.item.title}
//       <div className="">
//         <button onClick={() => handleEdit(props.item.id)}>
//           <img src={editIcon} alt="" />
//         </button>{" "}
//         <button
//           onClick={() => {
//             handleDelete(props.item.id);
//           }}
//         >
//           <img src={deleteIcon} alt="" />
//         </button>{" "}
//       </div>
//     </li>
//   );
// }

const DotorPopup = (props) => {
  const { show, closePopup, title, data, doctorId, reloadData = () => { }, } = props;
  const [items, setItems] = React.useState([]);
  const [allSpecializations, setAllSpecializations] = useState([]); // Store all specializations
  const [filteredSpecializations, setFilteredSpecializations] = useState([]); // Filtered specializations for display
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [value, setValue] = React.useState("");
  const [error, setError] = React.useState("");
  const [loader, setLoader] = React.useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const inputRef = useRef(null);

  const searchSpecializations = async (search) => {
    setLoader(true);
    try {
      let res = await listSpecializations(search);
      res = res.map(({ name }) => ({ text: name, value: name }));
      setAllSpecializations(res);
      setFilteredSpecializations(res);
      setIsInitialLoad(false);
    } catch (e) {
      console.error("Error fetching specializations:", e);
    }
    setLoader(false);
  };

  const handleLocalSearch = (searchText) => {
    setValue(searchText);

    if (searchText.trim() === "") {
      // Show all specializations when search is empty
      setFilteredSpecializations(allSpecializations);
      setShowSuggestions(true); // Keep suggestions visible when cleared
      return;
    }

    // Filter locally from allSpecializations
    const filtered = allSpecializations.filter(spec =>
      spec.text.toLowerCase().includes(searchText.toLowerCase())
    );

    setFilteredSpecializations(filtered);
    setShowSuggestions(true);
  };

  // Initial data fetch only once
  useEffect(() => {
    if (isInitialLoad) {
      searchSpecializations("");
    }
  }, [isInitialLoad]);

  // Set initial value if data is provided
  useEffect(() => {
    if (data?.length) setValue(data[0]);
  }, [data]);

  // Show suggestions when component is mounted and input is focused
  useEffect(() => {
    if (show && inputRef.current) {
      setShowSuggestions(true);
    }
  }, [show]);

  // const stages = {
  //   left: [
  //     {
  //       percent: 25,
  //       key: "stage2",
  //       icon: editIcon,
  //       color: "#c06c84",
  //       text: "Edit",
  //       action: (event, inst) => {
  //         handleEdit(event.index);
  //       },
  //     },
  //   ],
  //   right: [
  //     {
  //       percent: -25,
  //       key: "stage1",
  //       icon: "remove",
  //       color: "crimson",
  //       text: "Remove",
  //       action: (event, inst) => {
  //         handleDelete(event.index);
  //       },
  //     },
  //   ],
  // };

  const handleDelete = React.useCallback(
    async (id) => {
      setLoader(true);
      try {
        let arr = items.filter((item) => item.id !== id);
        arr = arr.map((item) => item.title);
        let res = await updateProfile({ id: doctorId, specialization: arr });
        if (res) {
          reloadData();
        }
      } catch (e) {
        console.error("Error", e);
      }
      setLoader(false);
    },
    [items, value, setItems]
  );

  // const handleEdit = React.useCallback(
  //   (index) => {
  //     let value = "";
  //     let data = items.filter((item) => {
  //       if (item.id != index) {
  //         return true;
  //       } else {
  //         value = item.title;
  //       }
  //     });
  //     setItems(data);
  //     setValue(value);
  //     document.getElementById("editInput").focus();
  //   },
  //   [items, setItems, setValue]
  // );

  const handleChange = async () => {
    setLoader(true);

    try {
      if (value.trim() == "") {
        setError("Enter value");
      } else {
        let res = await updateProfile({
          id: doctorId,
          specialization: [value],
        });
        if (res) {
          setValue("");
          reloadData();
        }
      }
    } catch (e) {
      console.error(e);
    }
    setLoader(false);
  };

  const handleSelectSuggestion = (suggestion) => {
    setValue(suggestion.text);
    setShowSuggestions(false);
  };

  const handleInputFocus = () => {
    // When input is focused, show the list of all specializations
    setShowSuggestions(true);

    // If we already have data but no filtered results are showing,
    // reset filtered to show all
    if (allSpecializations.length > 0 && filteredSpecializations.length === 0) {
      setFilteredSpecializations(allSpecializations);
    }
  };

  return (
    <>
      <Loader show={loader} />
      <Modal
        show={show}
        onHide={closePopup}
        backdrop="static"
        keyboard={false}
        dialogClassName="docg-modal"
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: "auto", height: "300px" }}>
          <div className="mbsc-row">
            <div className="mbsc-col-12">
              <div className="mbsc-col-12">
                <Input
                  ref={inputRef}
                  id="editInput"
                  placeholder={`Search ${title}`}
                  inputStyle="box"
                  labelStyle="floating"
                  value={value}
                  onChange={(event) => handleLocalSearch(event.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={() => {
                    // Small delay to allow click events on suggestions to complete
                    setTimeout(() => setShowSuggestions(false), 200);
                  }}
                  className="mb-2"
                />

                {showSuggestions && allSpecializations.length > 0 && (
                  <div className="mbsc-col-12 d-flex flex-column mt-2 overflow-auto"
                    style={{ maxHeight: "150px", border: "1px solid #ddd", borderRadius: "4px" }}>
                    {(filteredSpecializations.length > 0 ? filteredSpecializations : allSpecializations)
                      .slice(0, 20)
                      .map((item) => (
                        <div
                          onClick={() => handleSelectSuggestion(item)}
                          key={item.value}
                          className="p-2 hover-bg-light cursor-pointer"
                          style={{ cursor: "pointer", borderBottom: "1px solid #eee" }}
                        >
                          {item.text}
                        </div>
                      ))}
                  </div>
                )}
              </div>
              <div className="mbsc-col-12 d-flex align-items-end justify-content-center my-4">
                <button onClick={handleChange} className="docg-save-btn m-0">
                  Add
                </button>
              </div>
            </div>
            <div className="mbsc-col-12">
              <span className="mbsc-error-message mbsc-ios">{error}</span>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DotorPopup;
